import React from 'react';
import useSpotConfig from '@host-panel/request/config/use-config';
import EmbeddedReport from '../embedded-report/EmbeddedReport';
import SecondaryNavigation from '../../common/navigation/secondary-navigation';
import AnalyticsMonetization from '../monetization';

type Props = {
  spotId: string;
  page: string;
  isSuperAdmin?: boolean;
  enableMonetization: boolean;
};

const REVENUE_REPORT_URL_KEY = 'tenant.host_panel.revenueReportUrl';

const RevenueNext: React.FC<Props> = ({ spotId, page, isSuperAdmin, enableMonetization }) => {
  const [[revenueReportUrl]] = useSpotConfig([REVENUE_REPORT_URL_KEY], {
    [REVENUE_REPORT_URL_KEY]: ''
  });
  const components = [];
  const secondaryMenuItems = [];

  if (revenueReportUrl) {
    secondaryMenuItems.push({
      label: 'Overview',
      routeName: 'revenue-next',
      navParams: { spot_id: spotId }
    });
  }

  if (isSuperAdmin || enableMonetization) {
    secondaryMenuItems.push({
      label: 'Table View',
      routeName: 'revenue-monetization',
      navParams: { spot_id: spotId }
    });
  }

  components.push(
    <SecondaryNavigation key="1" title="Revenue" selected={page} menuItems={secondaryMenuItems} />
  );

  switch (page) {
    case 'revenue-next':
      if (revenueReportUrl) {
        components.push(
          <EmbeddedReport
            key="2"
            url={revenueReportUrl as string}
            trackEventName="revenue overview beta page viewed"
          />
        );
      }
      break;
    case 'revenue-monetization':
      if (isSuperAdmin || enableMonetization) {
        components.push(
          <AnalyticsMonetization
            key="3"
            spotId={spotId}
            trackEventName="revenue table beta page viewed"
          />
        );
      }
      break;
  }

  return <div className="preferences">{components}</div>;
};

export default RevenueNext;
